import { render, staticRenderFns } from "./DeleteStandard.vue?vue&type=template&id=0645de4f&"
import script from "./DeleteStandard.vue?vue&type=script&lang=js&"
export * from "./DeleteStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports